<div class="cell shrink grid-x align-justify align-middle">
    <h1 class="_primary cell auto">{{title}}</h1>

    <kiwi-all-periods-selector class="cell shrink"></kiwi-all-periods-selector>
</div>
